//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Rater from 'vux/src/components/rater/index.vue'
import MyRater from '@/components/rater/rater.vue'
import sliderItem from '@/components/slider/slider.vue'
export default {
  props: {
    desc: {
      type: String,
      default: '',
    },
    question: {
      type: Object,
      default: {},
    },
    src: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    blankVisible: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
  },
  components: {
    Rater,
    MyRater,
    sliderItem,
  },
  data() {
    return {
      currentLevelValue: 0,
    }
  },
  computed: {
    currentLevel() {
      return Number(this.question.level)
    },
    value() {
      if (this.currentLevelValue == 0) {
        return ''
      } else {
        return this.currentLevelValue
      }
    },
    icon() {
      let iconfont = 'xingxing'
      switch (this.question.style) {
        case 'star':
          iconfont = 'xingxing'
          break
        case 'heart':
          iconfont = 'heart'
          break
        case 'smile':
          iconfont = 'smile'
          break
        case 'like':
          iconfont = 'dianzan'
          break
        default:
          iconfont = 'xingxing'
      }
      return `<span class="iconfont icon-${iconfont}" style="font-size: 20px"></span>`
    },
  },
  methods: {},
}
